export default __webpack_public_path__ + "static/media/48.5a9a4d7f.jpeg";